<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span
      >&copy; {{ new Date().getFullYear() }}
      <a href="#!" target="_blank" rel="nofollow">Firewood ERP</a>, All rights
      Reserved</span
    >
    <span class="md:flex hidden items-center">
      <span>
        Designed & Developed by
        <a href="https://vue.co.ke" target="_blank" rel="nofollow"
          >Vue Analytics</a
        ></span
      >
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
  inject: {
    components: {
      default: {},
    },
  },
};
</script>
